// Rasterises the DOM h1 exactly as laid out (per-word positions) so the 3D title can hand off to it pixel-for-pixel.
export function drawTitleCanvas(el, dpr) {
  const box = el.getBoundingClientRect();
  const cs = getComputedStyle(el);
  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, Math.ceil(box.width * dpr));
  canvas.height = Math.max(1, Math.ceil(box.height * dpr));
  const ctx = canvas.getContext("2d");
  ctx.scale(dpr, dpr);
  ctx.font = `${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`;
  if ("letterSpacing" in ctx) ctx.letterSpacing = cs.letterSpacing;
  ctx.fillStyle = cs.color;
  ctx.textBaseline = "alphabetic";
  const m = ctx.measureText("Hg");
  const ascent = m.fontBoundingBoxAscent ?? m.actualBoundingBoxAscent;
  const range = document.createRange();
  const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
  for (let node = walker.nextNode(); node; node = walker.nextNode()) {
    for (const w of node.data.matchAll(/\S+/g)) {
      range.setStart(node, w.index);
      range.setEnd(node, w.index + w[0].length);
      const r = range.getClientRects()[0];
      if (r) ctx.fillText(w[0], r.left - box.left, r.top - box.top + ascent);
    }
  }
  return { canvas, aspect: box.height / box.width };
}
